import { createTheme, type Shadows } from '@mui/material/styles';

const theme = createTheme({
  shadows: [
    'none',
    '0px 4px 8px 0px rgba(52, 58, 64, 0.10)',
    '0px 4px 16px 0px rgba(52, 58, 64, 0.10)',
    '0px 16px 24px 0px rgba(52, 58, 64, 0.15)',
    ...Array(21).fill('none'),
  ] as Shadows,
});

export default theme.shadows;
